export enum ISupportedLocale { FrFR = 'fr-FR' };

export default ISupportedLocale;
